import { cn } from "@humanex/ui/libs";
import React from "react";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "ghost" | "inverse" | "inverse-outline" | "destructive";
  padding?: string | null;
  isDisabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Button = (props: IButton) => {
  const {
    children,
    className,
    variant = "default",
    onClick,
    isDisabled = false,
    padding = null,
    ...rest
  } = props;

  const baseClasses = cn(
    "cursor-pointer inline-flex items-center justify-center rounded-lg transition-colors duration-200 text-sm font-semibold",
    "disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none",
    padding === null ? "px-6 py-3" : padding
  );

  const variantClasses = {
    default: "bg-primary-500 hover:bg-primary-600 text-white",
    outline: "border border-primary-700 text-primary-700 hover:bg-primary/10 font-normal bg-transparent",
    ghost: "text-ink hover:bg-primary-50 font-normal bg-transparent",
    inverse: "bg-white text-ink hover:bg-surface",
    "inverse-outline":
      "border border-secondary-400 bg-transparent text-secondary-400 hover:bg-secondary-50 font-normal",
    destructive: "bg-error-500 hover:bg-error-600 text-white"
  };

  return (
    <button
      className={cn(baseClasses, variantClasses[variant], className)}
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
};
